import * as React from "react";

function SvgSquare(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" {...props}><path className="square_svg__st0" d="M0 0h200v200H0z" /></svg>;
}

export default SvgSquare;